import { render, staticRenderFns } from "./LinkMatchingProspectiveReceivableModal.vue?vue&type=template&id=4a0b9007&"
import script from "./LinkMatchingProspectiveReceivableModal.vue?vue&type=script&lang=js&"
export * from "./LinkMatchingProspectiveReceivableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports